import React, { useState, useEffect } from 'react'
import api, { getdetails } from '../api/api.list'
import moment from 'moment'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// import Modal from '../modal/modal.remarks';
import { Button, Modal } from 'react-bootstrap'
import ReactHTMLTableToExcel from 'react-html-table-to-excel'
//import DataTable from "@bit/adeoy.utils.data-table";

import ReactPaginate from 'react-paginate'
import './style.css'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import swal from 'sweetalert'
import $ from 'jquery'

toast.configure()

function findObjectByKey(array, key, value) {
  for (var i = 0; i < array?.length; i++) {
      if (array[i][key] === value) {
          return array[i];
      }
  }
  return null;
}

function Table({ list, getlist, getCount}) {
  const [mrnumber, setMrNumber] = useState('')
  const [name, setName] = useState('')
  const [insurance, setInsurance] = useState('')
  const [visitdate, setVisitDate] = useState('')
  const [requestdate, setRequestDate] = useState('')
  const [drname, setDrName] = useState('')
  const [remarks, setRemarks] = useState('')
  const [itemid, setItemId] = useState('')
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [modelOpening, setOpening] = useState(false)
  const [modelOpened, setOpened] = useState(false)
  const [offset, setOffset] = useState(0)
  const [perPage, setPerpage] = useState(10)
  const [currentPage, setCurrentpage] = useState(0)

  const [approvalid, setApprovalId] = useState('')
  const [orderingclinicianid, setOrderingClinicianId] = useState('')
  const [entryname, setEntryName] = useState('')
  const [authorizationdate, setAuthorizationDate] = useState(null)
  const [cptcode, setCptCode] = useState('')
  const [noofunit, setNoOfUnit] = useState('')
  const [payershare, setPayerShare] = useState('')
  const [patientshare, setPatientShare] = useState('')
  const [remark, setRemark] = useState('')
  const [applicationid, setApplicationId] = useState('')
  const [detailsId, setDetailsId] = useState('')
  const [details, setDetails] = useState([])
  //const slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
  const [btnText, setBtnText] = useState('Enter')
  const [instadetails,setInstaDetails]=useState([])
  const[subview,setSubView]=useState(false)
  

  // var DataTable = require('react-editable-table').DataTable;
  //const [lists,setList]=useState(list)
  const closeModal = () => {
    setModalIsOpen(false)
  }
  const closingModel = () => {
    setOpening(false)
  }

  const closedModel = () => {
    setOpened(false)
  }


  let slice = list.slice(offset, offset + perPage)
  const [pageCount, setPageCount] = useState(0)

  useEffect(() => {

    setPageCount(Math.ceil(list.length / perPage))
  }, [list])

  const handlePageClick = e => {
    const selectedPage = e.selected
    const offset = selectedPage * perPage
    console.log(offset)
    setCurrentpage(selectedPage)
    setOffset(offset)
    slice = list.slice(offset, offset + perPage)
  }
  const getDetails = (id) => {
    let data={
      id:id
    }
    api.getdetails(data).then(res => {
      //console.log(res.data)
      setDetails(res.data)
      //   if(res.data.length>0)
      //   {
      //   res.data.map((items)=>{
      //      setOrderingClinicianId(items.orderingclinicianid)
      //      setCptCode(items.cptcode)
      //      setNoOfUnit(items.noofunit)
      //      setApprovalId(items.approvalid)
      //     setAuthorizationDate(new Date(items.authorizationdate))
      //     setDetailsId(items._id)
      //   })
      //   setBtnText('Update')
      // }else{
      //   setOrderingClinicianId('')
      //      setCptCode('')
      //      setNoOfUnit('')
      //      setApprovalId('')
      //     setAuthorizationDate(null)
      //   setBtnText('Save')
      // }
    })
  }
  const getInstaDetails=(id)=>{
    api.getinstadetails({task_id:id}).then(res=>{
      console.log(res)
      var data=JSON.parse(res.data)
      setInstaDetails(data.Table)
    })
  }

  return (
    <>
      <div class='col-md-12'>
        <div class='card'>
          <div class='content table-responsive '>
            <div>
              {localStorage.role != 'ROLE_USER' &&
                list != null &&
                list.length > 0 && (
                  <ReactHTMLTableToExcel
                    className='btn btn-info'
                    table='export'
                    filename='ReportExcel'
                    sheet='Sheet'
                    buttonText='Export excel'
                  //style={{'margin':'10px'}}
                  />
                )}
            </div>

            <table id='approvals' class='table'>
              <thead>
                <tr>
                  <th>Sl.No</th>
                  <th>Mr Number</th>
                  <th>Dr.Name/Order</th>
                  <th>Approval Status</th>
                  <th>Name</th>
                  <th>Insurance</th>
                  <th>Visit Date</th>
                  <th>Request Received</th>
                  <th>Status Updated</th>
                  
                  
                  <th>Remarks</th>
                  {localStorage.role != 'ROLE_USER' && (
                    <>
                      <th>In Time</th>
                      <th>Out Time</th>
                      <th>Submitted By</th>
                      <th>Delete</th>
                      <th>Edit</th>

                    </>
                  )}
                  {localStorage.role != 'ROLE_USER' && 
                  <th style={{ 'text-align': 'center' }}>Approval Details</th>
}
                </tr>
              </thead>
              <tbody>
                {slice.map((item, index) => {
                  return (
                    <>
                    <tr>
                      <td>{offset + index + 1}
                      {localStorage.role == 'ROLE_USER' && 
                      <i class={'ti-arrow-circle-right'} style={{'margin-left':'5px','cursor':'pointer'}} onClick={()=>{
                        if(subview)
                        {
                          $('#arrow'+item._id).removeClass('ti-arrow-circle-down')
                          $('#arrow'+item._id).addClass('ti-arrow-circle-right')
                          $('#det'+item._id).css('display','none')
                          getDetails([])
                          getInstaDetails([])
                          //setApprovalId('')
                          //setAuthorizationDate(null)
                          //setOrderingClinicianId('')
                          setSubView(false)
                        }else{
                          $('#arrow'+item._id).removeClass('ti-arrow-circle-right')
                          $('#arrow'+item._id).addClass('ti-arrow-circle-down')
                          $('#det'+item._id).css('display','contents')
                          setApprovalId(item.approvalid)
                          setAuthorizationDate(item.authorizationdate)
                          setOrderingClinicianId(item.orderingclinicianid)
                          setEntryName(item.name)
                          getDetails(item._id)
                          getInstaDetails(item.approvalid)
                          setSubView(true)
                        }
                      }} id={'arrow'+item._id}></i>
                    }
                      </td>
                      <td>{item.mrnumber}</td>
                      <td>{item.drname}</td>
                      {localStorage.role != 'ROLE_USER' && (
                        <td>
                          <select
                            name='approvalstatus'
                            style={{ height: '35px' }}
                            class='form-control border-input'
                            value={item.approvalstatus}
                            onChange={e => {
                              // alert(e.target.value)
                              let status = e.target.value
                              let data = {
                                approvalstatus: status
                              }
                              api.updatelist(item._id, data).then(res => {
                               // getlist()
                                  //newlist(setstat)
                                getCount()
                                toast('Updated Sucessfully')
                                if (status == 2 || status == 4) {
                                  getDetails(item._id)
                                  setApplicationId(item._id)
                                  setApprovalId(item.approvalid)
                                  setAuthorizationDate(item.authorizationdate?item.authorizationdate:null)
                                  setOrderingClinicianId(item.drname)
                                  setEntryName(item.name)
                                  //getInstaDetails(item.approvalid)
                                  setOpened(true)

                                }
                              })
                            }}
                          >
                            <option value='5'>Cancelled</option>
                            <option value='4'>Partially Approved</option>
                            <option value='3'>Query</option>
                            <option value='2'>Approved</option>
                            <option value='1'>Denied</option>
                            <option value='0'>Pending</option>
                          </select>
                        </td>
                      )}
                      {localStorage.role == 'ROLE_USER' && (
                        <td>
                          {item.approvalstatus == 5 && 'Cancelled'}
                          {item.approvalstatus == 4 && 'Partially Approved'}
                          {item.approvalstatus == 3 && 'Query'}
                          {item.approvalstatus == 1 && 'Denied'}
                          {item.approvalstatus == 0 && 'Pending'}
                          {item.approvalstatus == 2 && 'Approved'}
                        </td>
                      )}
                      <td>{item.name}</td>
                      <td>{item.insurance}</td>
                      <td>
                        {item.visitdate != null
                          ? moment(item.visitdate).format('MMM DD, yyyy')
                          : ''}
                      </td>
                      <td>
                        {item.requestdate != null
                          ? moment(item.requestdate).format(
                            'MMM DD, yyyy h:mm a'
                          )
                          : ''}
                      </td>
                      <td>{moment(item.updatedAt).format('MMM DD, yyyy')}</td>
                      
                      
                      
                      {localStorage.role == 'ROLE_USER' && (
                        <td>{item.remarks}</td>
                      )}
                      {localStorage.role != 'ROLE_USER' && (
                        <td>
                          <input
                            type='text'
                            class='form-control border-input'
                            style={{ height: '35px' }}
                            value={item.remarks}
                            autoComplete="off" 
                            onClick={() => {
                              setRemarks(item.remarks)
                              setItemId(item._id)
                              setModalIsOpen(true)
                            }}
                          />
                        </td>
                      )}
                      {localStorage.role != 'ROLE_USER' && (
                        <>
                          <td>{moment(item.createdAt).format('LT')}</td>
                          <td>
                            {item.approvalstatus == 0
                              ? ''
                              : moment(item.updatedAt).format('LT')}
                          </td>
                          <td style={{'text-align':'center'}}>{item.createdby.username}</td>
                          <td style={{ 'text-align': 'center' }}>
                            <i
                              class='ti-trash'
                              onClick={() => {
                                // api.deletelist(item._id).then(res => {
                                //     getlist()
                                // })

                                swal({
                                  title: 'Are you sure want to delete?',
                                  text:
                                    'Once deleted, you will not be able to recover this details!',
                                  icon: 'warning',
                                  buttons: true,
                                  dangerMode: true
                                }).then(res => {
                                  if (res) {
                                    //console.log(item.createdby._id)
                                    if(localStorage.userid.indexOf(item.createdby._id)!=-1){
                                      api.deletelist(item._id).then(res => {
                                        swal('Sucesfully deleted!', {
                                          icon: 'success'
                                        })
                                        getlist()
                                      })
                                    }else{
                                      alert("You don't have permission!")
                                    }
                                    
                                  } else {
                                  }
                                })
                              }}
                            ></i>
                          </td>
                          <td style={{ 'text-align': 'center' }}>
                            <i
                              class='ti-write'
                              style={{ height: '35px' }}
                              onClick={() => {
                                setMrNumber(item.mrnumber)
                                setName(item.name)
                                setInsurance(item.insurance)
                                //alert(item.visitdate.split('T')[0])
                                setVisitDate(
                                  item.visitdate != null
                                    ? new Date(item.visitdate.split('T')[0])
                                    : ''
                                )
                                setRequestDate(
                                  item.requestdate != null
                                    ? new Date(item.requestdate)
                                    : ''
                                )
                                setDrName(item.drname)
                                setItemId(item._id)
                                setOpening(true)
                              }}
                            />
                          </td>


                        </>
                      )}
                      {localStorage.role != 'ROLE_USER' && 
                      <td style={{ 'text-align': 'center' }}>

                      {item.approvalstatus == 2 &&
                        <i class='ti-comments'
                          style={{ height: '60px' }}
                          onClick={() => {

                            getDetails(item._id)
                            setApplicationId(item._id)
                            setApprovalId(item.approvalid)
                            setAuthorizationDate(item.authorizationdate?item.authorizationdate:null)
                            setOrderingClinicianId(item.drname)
                            setEntryName(item.name)
                            //getInstaDetails(item.approvalid)
                            setOpened(true)

                          }}
                        ></i>
                        }
                        {item.approvalstatus == 4 &&
                        <i class='ti-comments'
                          style={{ height: '60px' }}
                          onClick={() => {

                            getDetails(item._id)
                            setApplicationId(item._id)
                            setApprovalId(item.approvalid)
                            setAuthorizationDate(item.authorizationdate?item.authorizationdate:null)
                            setOrderingClinicianId(item.drname)
                            setEntryName(item.name)
                            //getInstaDetails(item.approvalid)
                            setOpened(true)

                          }}
                        ></i>
                        }
                      </td>
                }
                    </tr>
                    <tr id={'det'+item._id} style={{'display':'none'}}>
                      <td colspan='16'>
                        {subview&&
                                <>
                                  <div class = 'row'>
                                  <div class='col-md-2' style={{'margin-left':'10px'}}>
                                  <label><b>Approval Id </b> - {approvalid}</label>
                                  </div>
                                  <div class='col-md-2'>
                                  <label><b>Clinician Id </b> -  {orderingclinicianid}</label>
                                  </div>
                                  <div class='col-md-3'>
                                  <label><b>Expiry Date</b> - {authorizationdate}</label>
                                  </div>
                                  </div> 
                        <table class='details'>
                          <tr>
                            <th>CPT Code</th>
                            <th>Qty</th>
                            <th>Consumed Qty</th>
                            <th>Balance Qty</th>
                            <th>Approved Payer Share</th>
                            <th>Approved Patient Share</th>
                            <th>Paid Payer Share</th>
                            <th>Remarks</th>
                          </tr>
                          {
                    details.map((item)=>{
                      var obj=findObjectByKey(instadetails, 'cptcode', item.cptcode);
                      var consumed=obj?obj.totalconsumedqty:0
                      var balance=obj?item.noofunit-obj.totalconsumedqty:item.noofunit
                      var patient=obj?parseFloat(obj.totalamount)-parseFloat(obj.claimamount):0
                      //var paid=obj?obj.totalamount:0
                      var insuarnce=obj?obj.claimamount:0
                      return(
                      <>
                      <tr>
                    {/* <td>{item.approvalid}</td>
                    <td>{item.orderingclinicianid}</td>
                    <td>{ moment(item.authorizationdate).format('ll') }</td> */}
                    <td>{item.cptcode}</td>
                    <td>{item.noofunit}</td>
                    <td>{consumed}</td>
                    <td>{balance}</td>
                  <td>{item.payershare}</td>
                  <td>{item.patientshare}</td>
                  <td>{insuarnce}</td>
                  <td>{item.remark}</td>
                    
                      </tr>
                      </>
                    )})
                  }
                        </table>
                        </>
                }
                      </td>
                    </tr>
                    </>
                  )
                })}
              </tbody>
            </table>
            <ReactPaginate
              previousLabel={'prev'}
              nextLabel={'next'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
            <div>
              <div style={{ display: 'none' }}>
                <table id='export' class='table'>
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Mr Number</th>
                      <th>Name</th>
                      <th>Insurance</th>
                      <th>Visit Date</th>
                      <th>Request Received Date</th>
                      <th>Status Updated on</th>
                      <th>Dr.Name/Order</th>
                      <th>Approval Status</th>
                      <th>Remarks</th>
                      <th>In Time</th>
                      <th>Out Time</th>
                      <th>Submitted By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((item, index) => {
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{item.mrnumber}</td>
                          <td>{item.name}</td>
                          <td>{item.insurance}</td>

                          <td>
                            {item.visitdate != null
                              ? moment(item.visitdate).format('MMM DD, yyyy')
                              : ''}
                          </td>
                          <td>
                            {moment(item.requestdate).format(
                              'MMM DD, yyyy h:mm a'
                            )}
                          </td>
                          <td>
                            {moment(item.updatedAt).format('MMM DD, yyyy')}
                          </td>
                          <td>{item.drname}</td>
                          <td>
                            {item.approvalstatus == 5 && 'Cancelled'}
                            {item.approvalstatus == 4 && 'Partially Approved'}
                            {item.approvalstatus == 3 && 'Query'}
                            {item.approvalstatus == 1 && 'Denied'}
                            {item.approvalstatus == 0 && 'Pending'}
                            {item.approvalstatus == 2 && 'Approved'}
                          </td>
                          <td>{item.remarks}</td>
                          <td>{moment(item.createdAt).format('LT')}</td>
                          <td>{moment(item.updatedAt).format('LT')}</td>
                          <td>{item.createdby.username}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <Modal show={modalIsOpen} onHide={closeModal}>
          <Modal.Header closeButton>
            <Modal.Title style={{ color: '#fff', margin: '0px 0 0px' }}>
              Remarks
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input
              type='text'
              class='form-control border-input'
              value={remarks}
              autoComplete="off" 
              onChange={e => {
                setRemarks(e.target.value)
              }}
            ></input>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={closeModal}>
              Close
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                let data = {
                  remarks: remarks
                }
                api.updatelist(itemid, data).then(res => {
                  getlist()
                })
                closeModal()
              }}
            >
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <div>
        <Modal show={modelOpening} onHide={closingModel}>
          <Modal.Header closeButton>
            <Modal.Title style={{ color: '#fff', margin: '0px 0 0px' }}>
              Edit Table
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class='row'>
              <div class='col-md-3'>
                <label>MrNumber</label>
                <input
                  type='text'
                  class='form-control border-input'
                  name='mrnumber'
                  autoComplete="off" 
                  value={mrnumber}
                  onChange={e => {
                    setMrNumber(e.target.value)
                  }}
                ></input>
              </div>
              <div class='col-md-3'>
                <label>Name</label>
                <input
                  type='text'
                  class='form-control border-input'
                  name='name'
                  autoComplete="off" 
                  value={name}
                  onChange={e => {
                    setName(e.target.value)
                  }}
                ></input>
              </div>
              <div class='col-md-3'>
                <label>Insurance</label>
                <input
                  type='text'
                  class='form-control border-input'
                  name='insurance'
                  autoComplete="off" 
                  value={insurance}
                  onChange={e => {
                    setInsurance(e.target.value)
                  }}
                ></input>
              </div>
              <div class='col-md-3'>
                <label>Dr Name</label>
                <input
                  type='text'
                  name='drname'
                  autoComplete="off" 
                  value={drname}
                  onChange={e => {
                    setDrName(e.target.value)
                  }}
                  class='form-control border-input'
                />
              </div>
            </div>
            <div class='row' style={{ 'margin-top': '10px' }}>
              <div class='col-md-5'>
                <label>Visit Date</label>
                <div class='form-control border-input'>
                  <DatePicker
                    selected={visitdate}
                    name='visitdate'
                    autoComplete="off" 
                    dateFormat='MMM d, yyyy'
                    value={visitdate}
                    onChange={e => {
                      //alert(e)
                      setVisitDate(e)
                    }}
                    class='form-control border-input'
                  />
                </div>
              </div>
              <div class='col-md-5'>
                <label>Request Date</label>
                <div class='form-control border-input'>
                  <DatePicker
                    selected={requestdate}
                    showTimeSelect
                    dateFormat='MMM d, yyyy h:mm aa'
                    timeIntervals={1}
                    name='requestdate'
                    autoComplete="off" 
                    value={requestdate}
                    onChange={e => {
                      setRequestDate(e)
                    }}
                    class='form-control border-input'
                  />
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant='secondary' onClick={closingModel}>
              Close
            </Button>
            <Button
              variant='primary'
              onClick={() => {
                let data = {
                  mrnumber: mrnumber,
                  insurance: insurance,
                  visitdate: visitdate,
                  requestdate: requestdate,
                  drname: drname,
                  name: name
                }

                api.updatelist(itemid, data).then(res => {
                  getlist()
                  toast('Edited Sucessfully')
                })

                closingModel()
              }}
            >
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <div>
        <Modal show={modelOpened} onHide={closedModel}>
          <Modal.Header closeButton>
            <Modal.Title style={{ color: '#fff', margin: '0px 0 0px' }}>
              Approval Details-{entryname}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class='row'>
              <div class='col-md-3'>
                <label>Approval Id</label>
                <input
                  type='text'
                  class='form-control border-input'
                  name='Approval Id'
                  autoComplete="off" 
                  value={approvalid}
                  onChange={e => {
                    setApprovalId(e.target.value)
                  }}
                ></input>
              </div>
              <div class='col-md-3'>
                <label>Clinician Id</label>
                <input
                  type='text'
                  class='form-control border-input'
                  name='Ordering Clinician Id'
                  autoComplete="off" 
                  value={orderingclinicianid}
                  onChange={e => {
                  setOrderingClinicianId({drname})
                  }}
                ></input>
              </div>
              <div class='col-md-3'>
                <label>Expiry Date</label>
                
                <input
                  type='text'
                  class='form-control border-input'
                  name='Expiry Date'
                  autoComplete="off" 
                  value={authorizationdate}
                  onChange={e => {
                    setAuthorizationDate(e.target.value)
                  }}
                ></input>
                  {/* <DatePicker
                    selected={authorizationdate}
                    dateFormat='MMM d, yyyy'
                    timeIntervals={1}
                    name='authorizationdate'
                    value={authorizationdate}
                    onChange={e => {
                      setAuthorizationDate(e)
                    }}
                    class='form-control border-input'
                  /> */}

                  
              </div>
              </div>
              <div class='row' style={{'margin-top':'10px'}}>
              <div class='col-md-2'>
                <label>CPT Code</label>
                <input
                  type='text'
                  name='CPT Code'
                  autoComplete="off" 
                  value={cptcode}
                  onChange={e => {
                  setCptCode(e.target.value)
                  }}
                  class='form-control border-input'
                />
              </div>
              <div class='col-md-2'>
                <label>Quantity</label>
                <input
                  type='text'
                  class='form-control border-input'
                  name='No.of Unit'
                  autoComplete="off" 
                  value={noofunit}
                  onChange={e => {
                  setNoOfUnit(e.target.value)
                  }}
                ></input>
                
              </div>
              
              {/* </div>
              <div class='row' style={{'margin-top':'10px'}}> */}
              <div class='col-md-2'>
                <label>Payer Share</label>
                <input
                  type='text'
                  name='Payer Share'
                  autoComplete="off" 
                  value={payershare}
                  onChange={e => {
                  setPayerShare(e.target.value)
                  }}
                  class='form-control border-input'
                />
              </div>
              <div class='col-md-2'>
                <label>Patient Share</label>
                <input
                  type='text'
                  name='Patient Share'
                  autoComplete="off" 
                  value={patientshare}
                  onChange={e => {
                  setPatientShare(e.target.value)
                  }}
                  class='form-control border-input'
                />
              </div>
              <div class='col-md-2'>
                <label>Remarks</label>
                <input
                  type='text'
                  name='Remarks'
                  autoComplete="off" 
                  value={remark}
                  onChange={e => {
                  setRemark(e.target.value)
                  }}
                  class='form-control border-input'
                />
              </div>
            
              <div class='col-md-2'>
              {localStorage.role != 'ROLE_USER' && (
            <Button
              variant='primary'
              style={{'margin-top':'21px'}}
              onClick={() => {
         
                if(btnText=="Enter")
                {
                  let data = {
                    cptcode: cptcode,
                    noofunit: noofunit,
                    applicationid:applicationid,
                    payershare: payershare,
                    patientshare: patientshare,
                    remark: remark
                    
                }
                if(cptcode !='' && noofunit !='') {     
                api.savedetails(data).then(res => {
                  
                  getDetails(applicationid)
                  toast('Saved Sucessfully')
                  //setApprovalId('')
                  //setOrderingClinicianId('')
                  //setAuthorizationDate(null)
                  setCptCode('')
                  setNoOfUnit('')
                  setPayerShare('')
                  setPatientShare('')
                  setRemark('')
                })}else{
                  //setOpened(true)
                  toast('Mandatory Fields')
                }
              }
              else{
                 let data = {
                  cptcode: cptcode,
                  noofunit: noofunit,
                  payershare: payershare,
                  patientshare: patientshare,
                  remark: remark
              }
                api.updatedetails(detailsId,data).then(res => {
                  console.log(res)
                  
                  getDetails(applicationid)
                  toast('Updated Sucessfully')
                  //setApprovalId('')
                  //setOrderingClinicianId('')
                  //setAuthorizationDate(null)
                  setCptCode('')
                  setNoOfUnit('')
                  setPayerShare('')
                  setPatientShare('')
                  setRemark('')
                  setBtnText('Enter')

                })
              }
               // closedModel()

              }}
            >
              {btnText}
            </Button>
            )}
              </div>
              
            </div>
            <hr style={{'width':'100%'}}/>
            <table style={{'width':'100%'}} class='details'> 
                  <tr>
                    {/* <th>Approval Id</th>
                    <th>Clinician Id</th>
                    <th>Expiry Date</th> */}
                    <th>CPT Code</th>
                    <th>Qty</th>
                    {/* <th>Consumed Qty</th> */}
                    {/* <th>Balance Qty</th> */}
                    <th>Approved Payer Share</th>
                    <th>Approved Patient Share</th>
                    {/* <th>Paid Payer Share</th> */}
                    <th>Remarks</th>
                    {localStorage.role != 'ROLE_USER' && (
                      <>
                    <th>Edit</th>
                    <th>Delete</th>
                    </>
                    )}
                  </tr>
                  {
                    details.map((item)=>{
                      // var obj=findObjectByKey(instadetails, 'cptcode', item.cptcode);
                      // var consumed=obj?obj.totalconsumedqty:0
                      // var balance=obj?item.noofunit-obj.totalconsumedqty:item.noofunit
                      // var patient=obj?parseFloat(obj.totalamount)-parseFloat(obj.claimamount):0
                      //var paid=obj?obj.totalamount:0
                      // var insuarnce=obj?obj.claimamount:0
                      return(
                      <>
                      <tr>
                    {/* <td>{item.approvalid}</td>
                    <td>{item.orderingclinicianid}</td>
                    <td>{ moment(item.authorizationdate).format('ll') }</td> */}
                    <td>{item.cptcode}</td>
                    <td>{item.noofunit}</td>
                    {/* <td>{consumed}</td> */}
                    {/* <td>{balance}</td> */}
                  <td>{item.payershare}</td>
                  <td>{item.patientshare}</td>
                  {/* <td>{insuarnce}</td> */}
                  <td>{item.remark}</td>
                    {localStorage.role != 'ROLE_USER' && (
                      <>
                    <td style={{'text-align':'center'}}>
                    <i class= 'ti-write'
                    style={{ height: '60px' }}
                    
                    onClick={() => {
                        
                        setCptCode(item.cptcode)
                        setNoOfUnit(item.noofunit)
                        setPayerShare(item.payershare)
                        setPatientShare(item.patientshare)
                        setRemark(item.remark)
                        setBtnText('Update')
                        setDetailsId(item._id)
                      }}
                  ></i>
                  </td>
                    <td style={{'text-align':'center'}}><i class='ti-trash'
                          style={{ height: '60px' }}
                          
                          onClick={() => {


                            swal({
                              title: 'Are you sure want to delete?',
                              text:
                                'Once deleted, you will not be able to recover this details!',
                              icon: 'warning',
                              buttons: true,
                              dangerMode: true
                            }).then(res => {
                              if (res) {
                                api.deletedetails(item._id).then(res => {
                                  swal('Sucesfully deleted!', {
                                    icon: 'success'
                                  })
                                  getDetails(applicationid)
                                })
                              } else {
                              }
                            })
                          }}
                          
                          ></i></td>
                          </>
                    )}
                      </tr>
                      </>
  )})
                  }
                </table>

          </Modal.Body>

          <Modal.Footer>
          {/* {authorizationdate&& authorizationdate<new Date()&& <label style={{'float':'left','color':'red','fontWeight':'bold'}}>This Approval Expired</label>} */}
          {/* { authorizationdate>=new Date()&& <label style={{'float':'left','color':'red','fontWeight':'bold'}}></label>} */}
          {localStorage.role != 'ROLE_USER' && (
            <>
          <Button variant='secondary' onClick={()=>{
          let data = {
              approvalid: approvalid,
              orderingclinicianid: orderingclinicianid,
              authorizationdate: authorizationdate
              }

              api.updatelist(applicationid, data).then(res => {
                  //getlist()
                  toast('Edited Sucessfully')
              })
          }}>
              Save
            </Button>
            </>
          )}
            <Button variant='secondary' onClick={closedModel}>
              Close
            </Button>

          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default Table
